var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"main"},[_c('Rate',{staticClass:"left",attrs:{"tips":55,"colorObj":_vm.colorObj}}),_vm._m(0)],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"right"},[_c('p',[_vm._v("开通经纪人总数："),_c('span',[_vm._v("25")])]),_c('p',[_vm._v("活跃经济人总数："),_c('span',[_vm._v("25")])])])
}]

export { render, staticRenderFns }